import { Scene } from '@babylonjs/core';
import { Engine } from './Engine';

export type GameMode = 'lobby' | 'sandbox' | 'obby' | 'tycoon';

export interface GameModeConfig {
  id: GameMode;
  name: string;
  description: string;
  icon: string;
  color: string;
  available: boolean;
}

export const GAME_MODES: GameModeConfig[] = [
  {
    id: 'sandbox',
    name: 'Sandbox',
    description: 'Construa livremente! Coloque e remova blocos sem limites.',
    icon: '🔨',
    color: '#4CAF50',
    available: true,
  },
  {
    id: 'obby',
    name: 'Obby',
    description: 'Pule entre plataformas e chegue ao final! Cuidado com os obstáculos.',
    icon: '🏃',
    color: '#2196F3',
    available: true,
  },
  {
    id: 'tycoon',
    name: 'Tycoon',
    description: 'Construa sua fábrica de doces e fique rico! Compre máquinas e ganhe dinheiro.',
    icon: '🏭',
    color: '#FF9800',
    available: true,
  },
];

export type GameStateChangeCallback = (mode: GameMode | null) => void;

export class GameManager {
  private static instance: GameManager | null = null;

  private engine: Engine;
  private currentMode: GameMode | null = null;
  private onStateChangeCallbacks: GameStateChangeCallback[] = [];

  private constructor(engine: Engine) {
    this.engine = engine;
  }

  public static getInstance(engine?: Engine): GameManager {
    if (!GameManager.instance) {
      if (!engine) {
        throw new Error('GameManager requires Engine on first initialization');
      }
      GameManager.instance = new GameManager(engine);
    }
    return GameManager.instance;
  }

  public getCurrentMode(): GameMode | null {
    return this.currentMode;
  }

  public setMode(mode: GameMode | null): void {
    if (this.currentMode !== mode) {
      this.currentMode = mode;
      this.notifyStateChange();
    }
  }

  public getEngine(): Engine {
    return this.engine;
  }

  public getScene(): Scene {
    return this.engine.getScene();
  }

  public onStateChange(callback: GameStateChangeCallback): void {
    this.onStateChangeCallbacks.push(callback);
  }

  public removeStateChangeListener(callback: GameStateChangeCallback): void {
    const index = this.onStateChangeCallbacks.indexOf(callback);
    if (index > -1) {
      this.onStateChangeCallbacks.splice(index, 1);
    }
  }

  private notifyStateChange(): void {
    for (const callback of this.onStateChangeCallbacks) {
      callback(this.currentMode);
    }
  }

  public getAvailableModes(): GameModeConfig[] {
    return GAME_MODES;
  }

  public getModeConfig(mode: GameMode): GameModeConfig | undefined {
    return GAME_MODES.find(m => m.id === mode);
  }
}
